<template>
  <div class="container" v-if="!isLoading">
    <div class="row">
      <div class="col-12">
        <TopNav class="mt-4" />
        <img class="mt-3" :src="`${logo}`" />
        <p class="mt-4 mb-3">
          {{ $t('SETTINGS.TEXT.CONNECT_YOUR_TWILIO_ACCOUNT') }}
        </p>
        <HMActivatedTag
          v-if="!inProgress && twilio.is_twilio_connected"
          :label="$t('SETTINGS.LABEL.CONNECTED')"
          class="my-3"
        />
      </div>
      <div class="col-12">
        <div class="form-group">
          <div>
            <hr class="mt-0 mb-4" />
            <form @submit.prevent="update">
              <HMTextInput
                type="text"
                :label="$t('SETTINGS.LABEL.YOUR_TWILIO_ACCOUNT_SID')"
                v-model="twilio.twilio_account_sid"
                name="Twilio Account SID"
                placeholder="ACf4bc1547f6b295daa5229abd85b3dd62"
              />
              <HMTextInput
                type="password"
                :label="$t('SETTINGS.LABEL.YOUR_TWILIO_AUTH_TOKEN')"
                v-model="twilio.twilio_auth_token"
                name="Twilio Auth Token"
                placeholder="106268bafff881205f0364519e8ff35e"
              />
              <p class="c-charcoal">
                {{ $t('SETTINGS.TEXT.TWILIO_NUMER_NAME_ID_OPTIONAL') }}
              </p>
              <HMTextInput
                type="text"
                :label="$t('SETTINGS.LABEL.YOUR_TWILIO_FROM_NUMBER')"
                v-model="twilio.twilio_from_phone_number"
                name="From phone number"
                placeholder="+15017250604"
              />
              <HMTextInput
                type="text"
                rules="max:64"
                :label="$t('SETTINGS.LABEL.YOUR_TWILIO_MESSAGING_SID')"
                v-model="twilio.twilio_messaging_service_sid"
                name="Alphanumeric sender ID"
                placeholder="MG119eb230bd4f9001c1a6cf252168b0cc"
              />
              <HMButton
                type="submit"
                color="brand"
                :loading="inProgress"
                :disabled="
                  inProgress ||
                  (!twilio.twilio_from_phone_number &&
                    !twilio.twilio_messaging_service_sid)
                "
              >
                {{ $t('GENERAL.BUTTON.SAVE') }}
              </HMButton>
              <HMButton
                v-if="twilio.is_twilio_connected"
                class="ml-3"
                color="primary"
                @click="remove"
                :loading="inProgress"
                :disabled="inProgress"
              >
                {{ $t('SETTINGS.BUTTON.DISCONNECT_FROM_TWILIO') }}
              </HMButton>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <div v-if="twilio.twilio_account_sid">
            <hr class="mt-0 mb-4" />
            <HMButton
              v-if="
                twilio.twilio_from_phone_number ||
                twilio.twilio_messaging_service_sid
              "
              color="outline-light-gray"
              @click="sendSMS"
            >
              {{ $t('SETTINGS.BUTTON.SEND_TEST_SMS') }}
            </HMButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';
import HMTextInput from '../../../components/common/HMTextInput';
import HMButton from '../../../components/common/HMButton';
import SendSMSModal from '../../../components/settings/SendSMSModal';

export default Vue.extend({
  name: 'TwilioIntegration',
  components: {
    HMButton,
    HMTextInput,
    TopNav,
  },
  computed: {},
  data() {
    return {
      logo: '/assets/images/integrations/twilio.svg',
      isLoading: true,
      inProgress: false,
      twilio: {},
    };
  },
  methods: {
    sendSMS() {
      this.$modal.show(SendSMSModal);
    },
    async update() {
      try {
        const validatedPhone = this.$filterPhone(
          this.twilio.twilio_from_phone_number,
          {
            plus: true,
            brackets: false,
            space: false,
            dash: false,
            areaCode: true,
          }
        );
        console.log(
          'this.twilio.twilio_from_phone_number=',
          this.twilio.twilio_from_phone_number
        );
        console.log('validatedPhone=', validatedPhone);
        this.twilio.twilio_from_phone_number = validatedPhone;
        try {
          this.inProgress = true;
          await this.$store.dispatch('setting/updateTwilio', this.twilio);
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t('SETTINGS.NOTIFICATIONS.TWILIO_SUCCESSFULLY_UPDATED'),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorToMessage(error.response),
          });
          this.twilio.twilio_account_sid = null;
          this.twilio.twilio_auth_token = null;
          this.twilio.is_twilio_connected = null;
        } finally {
          this.inProgress = false;
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Invalid phone number',
          text:
            'Please include the plus sign, your area code, no brackets, no spaces, no dashes',
        });
      }
    },
    remove() {
      this.twilio.twilio_account_sid = null;
      this.twilio.twilio_auth_token = null;
      this.twilio.twilio_from_phone_number = null;
      this.twilio.twilio_messaging_service_sid = null;
      this.update();
    },
    checkForAccountSid() {
      const code = this.$route.query.AccountSid;
      if (!code) return;

      const query = { ...this.$route.query };
      delete query.code;
      this.$router.replace({ query });

      this.twilio.twilio_account_sid = code;
      this.update();
    },
  },
  async mounted() {
    this.twilio = await this.$store.dispatch('setting/getTwilio');
    this.checkForAccountSid();
    this.isLoading = false;
  },
});
</script>

<style lang="scss" scoped></style>
